/* tab-edits.js — Curera tweaks (Oct 26, 2026), duplicate theme only.
   1) TM (™) shown small + superscript outside the menu.
   2) Home stats count up when scrolled into view.
   Undo: delete this file and its line in layout/theme.liquid ("Tab edits"). */
(function () {
  // 1. ™ -> <sup class="tab-tm">™</sup> (skips header menu, form controls, scripts)
  function supTM(root) {
    var skip = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|OPTION|SELECT|SUP|TITLE)$/;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (n.nodeValue.indexOf('\u2122') === -1) return NodeFilter.FILTER_REJECT;
        for (var p = n.parentNode; p && p !== root; p = p.parentNode) {
          if (p.nodeType === 1 && (skip.test(p.tagName) || p.tagName === 'HEADER')) return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var parts = n.nodeValue.split('\u2122'); var frag = document.createDocumentFragment();
      parts.forEach(function (t, i) {
        if (t) frag.appendChild(document.createTextNode(t));
        if (i < parts.length - 1) { var s = document.createElement('sup'); s.className = 'tab-tm'; s.textContent = '\u2122'; frag.appendChild(s); }
      });
      n.parentNode.replaceChild(frag, n);
    });
  }
  // 2. count-up for ".exp-sec" numbers (200,000+ / 30 Million+ / 4.9)
  function countUp() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = document.querySelectorAll('.exp-sec h3.inline-richtext');
    if (!els.length || !('IntersectionObserver' in window)) return;
    els.forEach(function (el) {
      var txt = el.textContent.replace(/\u2028/g, '').trim();
      var m = txt.match(/^([\d,]+(?:\.\d+)?)(.*)$/); if (!m) return;
      var target = parseFloat(m[1].replace(/,/g, '')); var decimals = (m[1].split('.')[1] || '').length;
      var commas = m[1].indexOf(',') > -1; var suffix = m[2];
      var fmt = function (v) { var s = v.toFixed(decimals); return commas ? Number(s).toLocaleString('en-US') : s; };
      el.style.minWidth = el.offsetWidth ? el.offsetWidth + 'px' : '';
      el.textContent = fmt(0) + suffix;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return; io.disconnect();
          var t0 = null, dur = 1600;
          function step(ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / dur); var ease = 1 - Math.pow(1 - k, 3);
            el.textContent = fmt(target * ease) + suffix; if (k < 1) requestAnimationFrame(step); else el.textContent = txt; }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }
  // 3. (round 2) Support heading line breaks on desktop: "Looking to get / in touch? / We're happy to help."
  function supportHeading() {
    var st = document.querySelector('.support-sec h3.inline-richtext strong'); if (!st || st.dataset.tabBr) return;
    var t = st.textContent.replace(/\s+/g, ' ').trim();
    var m = t.match(/^(Looking to get)\s+(in touch\?)\s*(We.re happy to help\.?)$/i); if (!m) return;
    st.innerHTML = m[1] + '<br class="tab-br-d"> ' + m[2] + '<br class="tab-br-d"> <span class="tab-nowrap-d">' + m[3] + '</span>'; st.dataset.tabBr = '1';
  }
  function run() { try { supTM(document.body); } catch (e) {} try { countUp(); } catch (e) {} try { supportHeading(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
